var _line, _line2, _line3, _line4, _line5, _line6, _line7, _line8, _line9, _path, _circle, _circle2, _circle3, _circle4, _circle5, _circle6, _circle7, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgAppwork(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1320,
    height: 594,
    viewBox: "0 0 1320 594",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 18.5,
    y1: 215,
    x2: 18.5,
    y2: 139,
    stroke: "black",
    strokeDasharray: "5 5"
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    x1: 216.5,
    y1: 494,
    x2: 216.5,
    y2: 418,
    stroke: "black",
    strokeDasharray: "5 5"
  })), _line3 || (_line3 = /*#__PURE__*/React.createElement("line", {
    x1: 742.5,
    y1: 506,
    x2: 742.5,
    y2: 430,
    stroke: "black",
    strokeDasharray: "5 5"
  })), _line4 || (_line4 = /*#__PURE__*/React.createElement("line", {
    x1: 477.5,
    y1: 592,
    x2: 477.5,
    y2: 516,
    stroke: "black",
    strokeDasharray: "5 5"
  })), _line5 || (_line5 = /*#__PURE__*/React.createElement("line", {
    x1: 1066.5,
    y1: 594,
    x2: 1066.5,
    y2: 518,
    stroke: "black",
    strokeDasharray: "5 5"
  })), _line6 || (_line6 = /*#__PURE__*/React.createElement("line", {
    x1: 898.5,
    y1: 76,
    x2: 898.5,
    y2: 2.18558e-8,
    stroke: "black",
    strokeDasharray: "5 5"
  })), _line7 || (_line7 = /*#__PURE__*/React.createElement("line", {
    x1: 1300.5,
    y1: 215,
    x2: 1300.5,
    y2: 139,
    stroke: "black",
    strokeDasharray: "5 5"
  })), _line8 || (_line8 = /*#__PURE__*/React.createElement("line", {
    x1: 603.5,
    y1: 212,
    x2: 603.5,
    y2: 136,
    stroke: "black",
    strokeDasharray: "5 5"
  })), _line9 || (_line9 = /*#__PURE__*/React.createElement("line", {
    x1: 341.5,
    y1: 83,
    x2: 341.5,
    y2: 7,
    stroke: "black",
    strokeDasharray: "5 5"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.504941 226.852C0.504941 237.067 8.78546 245.347 19 245.347C29.2145 245.347 37.4951 237.067 37.4951 226.852C37.4951 216.638 29.2145 208.357 19 208.357C8.78546 208.357 0.504941 216.638 0.504941 226.852ZM1282.92 226.852C1282.92 237.067 1291.21 245.347 1301.42 245.347C1311.63 245.347 1319.92 237.067 1319.92 226.852C1319.92 216.638 1311.63 208.357 1301.42 208.357C1291.21 208.357 1282.92 216.638 1282.92 226.852ZM19 230.32H83.9438V223.384H19V230.32ZM136.828 283.204V345.192H143.764V283.204H136.828ZM196.648 405.012H216.382V398.076H196.648V405.012ZM276.202 345.192V154.028H269.267V345.192H276.202ZM329.087 101.144H356.601V94.208H329.087V101.144ZM409.485 154.028V449.226H416.421V154.028H409.485ZM469.305 509.046H477.897V502.111H469.305V509.046ZM537.717 449.226V283.204H530.781V449.226H537.717ZM590.601 230.32H617.335V223.384H590.601V230.32ZM670.22 283.204V366.567H677.155V283.204H670.22ZM729.037 425.385H757.776V418.449H729.037V425.385ZM816.594 366.567V170.026H809.658V366.567H816.594ZM885.476 101.144H904.5V94.208H885.476V101.144ZM973.382 170.026V422.228H980.317V170.026H973.382ZM1060.2 509.046H1063.08V502.111H1060.2V509.046ZM1149.9 422.229V283.204H1142.96V422.229H1149.9ZM1202.78 230.32H1301.42V223.384H1202.78V230.32ZM1149.9 283.204C1149.9 253.997 1173.58 230.32 1202.78 230.32V223.384C1169.75 223.384 1142.96 250.167 1142.96 283.204H1149.9ZM1063.08 509.046C1111.03 509.046 1149.9 470.177 1149.9 422.229H1142.96C1142.96 466.346 1107.2 502.111 1063.08 502.111V509.046ZM973.382 422.228C973.382 470.177 1012.25 509.046 1060.2 509.046V502.111C1016.08 502.111 980.317 466.346 980.317 422.228H973.382ZM904.5 101.144C942.542 101.144 973.382 131.983 973.382 170.026H980.317C980.317 128.153 946.373 94.208 904.5 94.208V101.144ZM816.594 170.026C816.594 131.983 847.433 101.144 885.476 101.144V94.208C843.603 94.208 809.658 128.153 809.658 170.026H816.594ZM757.776 425.385C790.26 425.385 816.594 399.051 816.594 366.567H809.658C809.658 395.221 786.43 418.449 757.776 418.449V425.385ZM670.22 366.567C670.22 399.051 696.553 425.385 729.037 425.385V418.449C700.384 418.449 677.155 395.221 677.155 366.567H670.22ZM617.335 230.32C646.542 230.32 670.22 253.997 670.22 283.204H677.155C677.155 250.167 650.373 223.384 617.335 223.384V230.32ZM537.717 283.204C537.717 253.997 561.394 230.32 590.601 230.32V223.384C557.563 223.384 530.781 250.167 530.781 283.204H537.717ZM477.897 509.046C510.934 509.046 537.717 482.264 537.717 449.226H530.781C530.781 478.434 507.104 502.111 477.897 502.111V509.046ZM409.485 449.226C409.485 482.264 436.267 509.046 469.305 509.046V502.111C440.098 502.111 416.421 478.434 416.421 449.226H409.485ZM356.601 101.144C385.808 101.144 409.485 124.821 409.485 154.028H416.421C416.421 120.99 389.638 94.208 356.601 94.208V101.144ZM276.202 154.028C276.202 124.821 299.879 101.144 329.087 101.144V94.208C296.049 94.208 269.267 120.99 269.267 154.028H276.202ZM216.382 405.012C249.42 405.012 276.202 378.229 276.202 345.192H269.267C269.267 374.399 245.59 398.076 216.382 398.076V405.012ZM136.828 345.192C136.828 378.229 163.61 405.012 196.648 405.012V398.076C167.441 398.076 143.764 374.399 143.764 345.192H136.828ZM83.9438 230.32C113.151 230.32 136.828 253.997 136.828 283.204H143.764C143.764 250.167 116.981 223.384 83.9438 223.384V230.32Z",
    fill: "url(#paint0_linear_189_942)"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 604.096,
    cy: 228.584,
    r: 21.6739,
    fill: "#5F4CCB"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 341.674,
    cy: 97.6739,
    r: 21.6739,
    fill: "#6D9CC4"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 477.674,
    cy: 505.674,
    r: 21.6739,
    fill: "#5D72CA"
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 743.002,
    cy: 417.58,
    r: 21.6739,
    fill: "#8D59AC"
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    cx: 216.674,
    cy: 401.674,
    r: 21.6739,
    fill: "#7CBDC0"
  })), _circle6 || (_circle6 = /*#__PURE__*/React.createElement("circle", {
    cx: 898.377,
    cy: 97.6739,
    r: 21.6739,
    fill: "#C56591"
  })), _circle7 || (_circle7 = /*#__PURE__*/React.createElement("circle", {
    cx: 1064.7,
    cy: 506.01,
    r: 21.6739,
    fill: "#D57F81"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_189_942",
    x1: 19.5184,
    y1: 352.994,
    x2: 1498.91,
    y2: 352.994,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#99EEB9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.168732,
    stopColor: "#7ABAC0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.304701,
    stopColor: "#6080C6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.397831,
    stopColor: "#5147D4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.487235,
    stopColor: "#7C54B3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.598991,
    stopColor: "#A85E9F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.695298,
    stopColor: "#D86986"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.822502,
    stopColor: "#CFA176"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.921219,
    stopColor: "#CEA076"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAppwork);
export default __webpack_public_path__ + "static/media/appwork.99480bd4b3de4ad99609d5c33d2ba070.svg";
export { ForwardRef as ReactComponent };